import {DefaultResType, ErrorType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {PcsSearchParamType} from "../../pages/purchase/pcs/list/interface";
import {PcsDetailType, PcsSubjectElementType} from "../../pages/purchase/pcs/detail/interface";

const url = "api/purchaseOrder/";

export async function readPurchaseOrderList(param: PcsSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_purchase_order_list", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readPurchaseOrderDetail(data: { purchaseOrderId: number }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_purchase_order_detail", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readPurchaseOrderSubject(data: { purchaseOrderId: number }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_purchase_order_subject", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function savePurchaseOrder(data: PcsDetailType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "save_purchase_order", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function savePurchaseOrderSubject(data: PcsSubjectElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "save_purchase_order_subject", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportPurchaseOrders(param: PcsSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_purchase_orders", param, {
        responseType: "blob",
    });

    return response?.data;
}

// 납품 목록 조회
export async function readDeliveryList(param: PcsSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_delivery_list", param);
    } catch (err: any) {
        return err?.response;
    }
}